
import React from 'react';
import { 
  CommandEmpty, 
  CommandGroup, 
  CommandItem 
} from '@/components/ui/command';
import { Button } from '@/components/ui/button';
import { type Contact } from './types';
import ContactCard from './ContactCard';

interface ContactsListProps {
  contacts: Contact[];
  onSelectContact: (contact: Contact) => void;
  onShowManualEntry: () => void;
}

const ContactsList: React.FC<ContactsListProps> = ({ 
  contacts, 
  onSelectContact, 
  onShowManualEntry 
}) => {
  return (
    <>
      <CommandEmpty>
        <div className="p-4 text-center">
          <p className="text-sm text-muted-foreground">No contacts found</p>
          <Button 
            variant="link" 
            className="mt-2"
            onClick={onShowManualEntry}
          >
            Enter email address manually
          </Button>
        </div>
      </CommandEmpty>
      
      <CommandGroup heading="Your Contacts">
        {contacts.map(contact => (
          <CommandItem 
            key={contact.id} 
            onSelect={() => onSelectContact(contact)}
            className="p-0 cursor-pointer"
          >
            <ContactCard 
              contact={contact} 
              onSelect={onSelectContact} 
            />
          </CommandItem>
        ))}
      </CommandGroup>
      
      <div className="p-2 border-t">
        <Button 
          variant="outline" 
          className="w-full text-sm"
          onClick={onShowManualEntry}
        >
          Enter email address manually
        </Button>
      </div>
    </>
  );
};

export default ContactsList;
